import { AddCircleOutlineRounded, AddCircleRounded } from "@mui/icons-material";
import { Box } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
  AccordionText,
  CardContainer,
  GridContainerStyled,
  TaglineContainer,
  TaglineTitle,
} from "./styles";

export default function FreeFaq() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = content_my;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Start Hiring with These Benefits Today";
  const buttonColour = "black";
  const posthog = usePostHog();

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "solutions",
    });
  }

  function DynamicAccordion({ items }) {
    const [expanded, setExpanded] = useState([]);

    const handleChange = (panel) => (event, isExpanded) => {
      if (isExpanded) {
        setExpanded((prev) => [...prev, panel]); // allow multiple open
      } else {
        setExpanded((prev) => prev.filter((p) => p !== panel));
      }
    };
    return (
      <>
        {items?.map((item, index) => {
          const isOpen = expanded.includes(index);
          return (
            <AccordionStyled
              key={index}
              expanded={isOpen}
              onChange={handleChange(index)}
            >
              <AccordionSummaryStyled
                expandIcon={
                  isOpen ? (
                    <AddCircleRounded sx={{ fontSize: 48 }} />
                  ) : (
                    <AddCircleOutlineRounded sx={{ fontSize: 48 }} />
                  )
                }
              >
                <AccordionText type={"title"} expanded={isOpen}>
                  {item?.title}
                </AccordionText>
              </AccordionSummaryStyled>
              <AccordionDetailsStyled>
                <AccordionText
                  type={"description"}
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                ></AccordionText>
              </AccordionDetailsStyled>
            </AccordionStyled>
          );
        })}
      </>
    );
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((solution, index) => (
        <>
          <TaglineContainer>
            <TaglineTitle
              dangerouslySetInnerHTML={{ __html: solution?.title }}
            ></TaglineTitle>
          </TaglineContainer>
        </>
      ))}

      <CardContainer>
        <Box sx={{ width: "100%", padding: "0px" }}>
          <DynamicAccordion items={solutionsCard[0]?.items} />
        </Box>
      </CardContainer>
    </GridContainerStyled>
  );
}
